import { PsychologyOutlined } from "@mui/icons-material";
import { Avatar, Box, List, ListItem, Stack } from "@mui/material";
import { SLTypography } from "components/slTypography";
import {
  ArrowForwardIosIcon,
  CeoImage,
  ForumOutlined,
  SupernalWorldIcon,
} from "helpers/enum/constants";
import { useNavigate } from "react-router-dom";

const profileLinks = [
  {
    iconButton: <PsychologyOutlined sx={{ width: "18px", height: "18px" }} />,
    name: "How it Works",
    redirectionLink: "/app/how-it-works",
  },
  {
    iconButton: (
      <Box
        component="img"
        className="purple-icon"
        src={SupernalWorldIcon}
        alt="/"
        sx={{ width: "18px", height: "18px" }}
      />
    ),
    name: "About Supernal World Creations",
    redirectionLink: "/app/supernal-world-creation",
  },
  {
    iconButton: <ForumOutlined sx={{ width: "18px", height: "18px" }} />,
    name: "Contact Us",
    redirectionLink: "/app/contact-us",
  },
];

const InfoAboutCeo = () => {
  const navigate = useNavigate();

  return (
    <>
      <Box>
        <Stack>
          <Avatar
            tabIndex={0}
            alt="image of Dr. Dawn Ella"
            src={CeoImage}
            sx={{
              width: { xs: "90px", sm: "120px" },
              height: { xs: "90px", sm: "120px" },
              marginTop: "30px",
              marginBottom: { xs: "15px", sm: "20px" },
            }}
          />
          <SLTypography
            tabIndex={0}
            variant="heading"
            sx={{
              paddingBottom: "15px",
              letterSpacing: "-.3px",
              fontSize: { xs: "19px", sm: "27px" },
            }}
            role="heading"
          >
            Dr. Dawn Ella – President, Inventor & Creative Director
          </SLTypography>
          <SLTypography
            tabIndex={0}
            variant="smallBody"
            sx={{
              paddingTop: "12px",
              paddingBottom: "50px",
              fontSize: { xs: "14px", sm: "17px" },
            }}
          >
            Dr. Dawn Ella is a pioneer in the intersection of sound and science,
            dedicated to advancing wellness through innovative technology.
            <br />
            <br />
            Her journey into wellness research was profoundly shaped by the
            birth of her son, Michael, and later deepened in 2006 when a
            life-altering experience reinforced her understanding of the mind’s
            adaptability. Recognizing the brain’s remarkable ability to respond
            to sound and frequency from an early age, she explored how
            structured auditory and visual stimuli could support cognitive and
            emotional well-being.
            <br />
            <br />
            As a researcher and wellness advocate, Dr. Dawn Ella has dedicated
            her career to developing accessible tools for enhancing mental and
            physical health. In 2019, she founded Supernal World Creations, a
            nonprofit organization committed to improving individual and
            community wellness through humanitarian innovation.
            <br />
            <br />
            Backed by extensive research since 1996, Soul Link is a
            comprehensive wellness system that leverages audiovisual technology
            to encourage relaxation, mental clarity, and overall well-being;
            offering an accessible, science-driven approach to supporting
            wellness for people of all backgrounds.
          </SLTypography>
          <List
            sx={{
              //   width: { lg: "100%", md: "100%", xs: "100%" },
              width: 1,
            }}
          >
            {profileLinks.map((data: any, index) => {
              return (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* <Link
                      key={"sidebaritem_id" + index}
                      to={data.redirectionLink}
                      style={{ textDecoration: "none", width: "100%" }}
                      tabIndex={-1}
                    > */}
                    <ListItem
                      //   onClick={() => handleListItems(data)}
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                        borderRadius: "10px",
                        background: "#FFFFFF",
                        cursor: "pointer",
                        color: "var(--sl-deep-purple)",
                        height: "50px",
                        textDecoration: "none",
                      }}
                      tabIndex={0}
                      onClick={() => {
                        navigate(data.redirectionLink);
                      }}
                      onKeyPress={() => {
                        navigate(data.redirectionLink);
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          fontSize: { xs: "14px" },
                        }}
                      >
                        {data.iconButton}

                        <SLTypography
                          variant="title"
                          sx={{ fontSize: { xs: "14px" } }}
                        >
                          {data.name}
                        </SLTypography>
                      </Box>
                      <ArrowForwardIosIcon sx={{ fontSize: "12px" }} />
                    </ListItem>
                    {/* </Link> */}
                  </Box>
                </>
              );
            })}
          </List>
        </Stack>
      </Box>
    </>
  );
};

export default InfoAboutCeo;
